import {
  AutocompleteResponse,
  AutocompleteSuggestion,
  queryAssistanceClient,
} from '@dynatrace-sdk/client-query';

export type SuggestionCache = Map<
  string,
  { suggestions: AutocompleteSuggestion[]; ttl?: number }
>;

const globalCache: SuggestionCache = new Map();

/** Gets memoized suggestions. */
export const getSuggestions: (
  query: string,
  cursor?: number,
  cache?: SuggestionCache,
) => Promise<AutocompleteSuggestion[]> = async (
  query,
  _cursor,
  cache = globalCache,
) => {
  const cursor = _cursor ?? query.length;
  const key = JSON.stringify({ query, cursor });
  const currentTime = new Date().getTime();

  const cacheHit = cache.get(key);
  if (cacheHit && (cacheHit.ttl ? cacheHit.ttl > currentTime : true)) {
    return cacheHit.suggestions;
  } else {
    cache.delete(key);

    const { suggestions, suggestedTtlSeconds } =
      await getSuggestionsFromQueryEndpoint(query, cursor);

    cache.set(key, {
      suggestions: suggestions ?? [],
      ttl:
        suggestedTtlSeconds !== undefined
          ? new Date().getTime() + suggestedTtlSeconds * 1000
          : undefined,
    });

    return suggestions;
  }
};

/** Gets suggestions from autocomplete endpoint. */
async function getSuggestionsFromQueryEndpoint(
  query: string,
  cursor: number,
): Promise<AutocompleteResponse> {
  try {
    const response = await queryAssistanceClient.queryAutocomplete({
      body: { query, cursorPosition: cursor },
    });
    return response;
  } catch {
    //nothing
  }
  return { suggestions: [], suggestedTtlSeconds: undefined, optional: false };
}
